import { Pipe, PipeTransform } from '@angular/core';
import { IdeaEvidence } from '@models/Sessions/Idea/evidence';
import { FilterByPipe } from '@pipes/array/filter-by.pipe';
import { getUsedEvidence } from '@utils/text-content';

@Pipe({
  name: 'filterUsedCitations',
  standalone: true,
})
export class FilterUsedCitationsPipe
  extends FilterByPipe<IdeaEvidence>
  implements PipeTransform
{
  override transform(
    evidence: IdeaEvidence[],
    ideaContent: string,
  ): IdeaEvidence[] {
    if (!ideaContent) {
      return evidence;
    }
    const usedEvidence = getUsedEvidence(ideaContent);
    return super.transform(evidence, (val: IdeaEvidence) =>
      (usedEvidence || []).includes(val.citation),
    );
  }
}
